import { http } from '../../core/services/http';

export const loadVendors = (vendorName?: string, status?: string, page?: number, limit?: number, sortOrder?: string, sortDirection?: string) =>
  http
    .get('/vendors', { params: { vendorName, status, page, limit, sortOrder, sortDirection } })
    .then(response => response.data);

